"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSNavigationMenu = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
/** @jsxRuntime classic */
/** @jsx jsx */
var react_2 = require("@emotion/react");
var Theme_1 = require("../../../../Theme");
var BDSNavigationMenu_style_1 = require("./BDSNavigationMenu.style");
var BDSNavigationSubMenu_1 = require("../BDSNavigationSubMenu/BDSNavigationSubMenu");
var BDSNewAlarm_1 = require("../../../common/BDSNewAlarm/BDSNewAlarm");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var styleCss = BDSNavigationMenu_style_1.BDSNavigationMenuStyle;
var BDSNavigationMenu = function (props) {
    var theme = Theme_1.lightTheme;
    var themeCss = react_2.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n    span,\n    .sub-button-panel button {\n      color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    span,\n    .sub-button-panel button {\n      color: ", ";\n    }\n  "])), theme.colors.bg1, theme.colors.text02);
    var propsObj = props;
    var _a = react_1.useState(undefined), subMenuActiveIndex = _a[0], setSubMenuActiveIndex = _a[1];
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "icon-button-panel " + (propsObj.active ? 'active' : ''), css: [styleCss, themeCss], style: propsObj.style ? propsObj.style : {} }, { children: [jsx_runtime_1.jsxs("button", tslib_1.__assign({ type: "button", className: "icon-button-item", onClick: function () {
                    if (props.handleOnClick) {
                        props.handleOnClick();
                    }
                } }, { children: [propsObj.icon && (jsx_runtime_1.jsx(BDSNewAlarm_1.BDSNewAlarm, tslib_1.__assign({ isActiveAlarm: (propsObj === null || propsObj === void 0 ? void 0 : propsObj.isActiveAlarm) || false, wrapperStyle: { marginRight: '10px' } }, { children: jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: propsObj.icon, color: propsObj.active ? '#3D4046' : '#7E8696', size: "20px" }, void 0) }), void 0)),
                    !props.isSmall && propsObj.label && jsx_runtime_1.jsx("span", { children: propsObj.label }, void 0)] }), void 0),
            !props.isSmall &&
                propsObj.menu &&
                propsObj.menu.map(function (menuItem, index) { return (jsx_runtime_1.jsx(BDSNavigationSubMenu_1.BDSNavigationSubMenu, { id: menuItem.id, label: menuItem.label, active: menuItem.isActive !== undefined ? menuItem.isActive : subMenuActiveIndex === index, handleOnClick: function () {
                        setSubMenuActiveIndex(undefined);
                        setSubMenuActiveIndex(index);
                        if (propsObj.handleOnClick)
                            propsObj.handleOnClick(menuItem.link);
                    } }, menuItem.id)); })] }), void 0));
};
exports.BDSNavigationMenu = BDSNavigationMenu;
var templateObject_1;
